module.exports = __webpack_public_path__ + "img/b2c-img-refer-top.5628325e.png";